export default __webpack_public_path__ + "static/media/banner-10.8b4df302.png";